module.exports = __webpack_public_path__ + "img/SANTAS BEARD.478fcf8.svg";